import { ReactNode } from "react"

export type AnimationDirectionIntent = "auto" | "left" | "right"

export enum AnimationDirectionValue {
    LEFT = -1,
    RIGHT = 1,
    NONE = 0,
}

export interface ComponentNavigationContextValues {
    currentComponentId: string | null
    componentIds: string[]
    animationDirection: AnimationDirectionValue
    isComponentTransitioning: boolean
    transitionDurationMS: number
    keepMounted: boolean
    contentHeight: number | undefined
    setContentHeight: (height: number) => void
    navigate: (componentId: string, direction?: AnimationDirectionIntent) => void
}

interface ComponentNavigationBaseProps {
    children: ReactNode
    initialComponentId?: string
    currentComponentId?: string
    componentIds?: string[]
    transitionDurationMS?: number
    keepMounted?: boolean
    className?: string
    onNavigate?: (componentId: string) => void
}

interface ComponentNavigationWithHistory extends ComponentNavigationBaseProps {
    persistToHistory: true
    historyKey: string
}

interface ComponentNavigationWithoutHistory extends ComponentNavigationBaseProps {
    persistToHistory?: false
    historyKey?: string
}

export type ComponentNavigationProps = ComponentNavigationWithHistory | ComponentNavigationWithoutHistory

export interface ComponentNavigationRootProps {
    children: ReactNode
    className?: string
}
